import React from "react";
import styles from "./style/surveyBlockUniversal.module.css";


const SurveyCommon = ({option, valStyle, isSelected, onChange, index_option}) => {
  return (
    <div 
      onClick={() => onChange(index_option)} 
      className={`${styles.circlesInput} ${valStyle === "square_checkmark" ? styles.multipleChoice : ''}
      ${isSelected ? styles.circlesInputActivated : ''}`}
    >
      <div className={styles.inputCircleCon}>
        <div className={styles.inputCircle}></div>
      </div>
      <p className={styles.inputName}>{option}</p>
    </div>
  );
};

export default SurveyCommon;
